<template>
  <div class="prism-player" :id="playerId"></div>
</template>
<script>
export default {
  props: {
    playStyle: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    isLive: {
      type: Boolean,
      default: false,
    },
    playsinline: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    controlBarVisibility: {
      type: String,
      default: "always",
    },
    useH5Prism: {
      type: Boolean,
      default: false,
    },
    useFlashPrism: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
      default: "",
    },
    playauth: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      default: "",
    },
    cover: {
      type: String,
      default: "",
    },
    format: {
      type: String,
      default: "m3u8",
    },
    x5_video_position: {
      type: String,
      default: "top",
    },
    x5_type: {
      type: String,
      default: "h5",
    },
    x5_fullscreen: {
      type: Boolean,
      default: false,
    },
    x5_orientation: {
      type: Number,
      default: 2,
    },
    autoPlayDelay: {
      type: Number,
      default: 0,
    },
    autoPlayDelayDisplayText: {
      type: String,
    },
  },
  data() {
    return {
      playerId: null,
      scriptTagStatus: 0,
      isReload: false,
      instance: null,
    };
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      const _this = this;
      if (!this.playerId)
        // this.playerId = "aliplayer_" + this.uuid.v1();
        this.playerId = "aliplayer_" + Math.random() * 100000000000000000;
      this.$nextTick(() => {
        this.instance = new window.Aliplayer(
          {
            id: _this.playerId,
            source: _this.source,
            autoplay: _this.autoplay,
            isLive: _this.isLive,
            playsinline: _this.playsinline,
            format: _this.format,
            width: _this.width,
            height: _this.height,
            controlBarVisibility: _this.controlBarVisibility,
            useH5Prism: _this.useH5Prism,
            useFlashPrism: _this.useFlashPrism,
            vid: _this.vid,
            playauth: _this.playauth,
            cover: _this.cover,
            x5_video_position: _this.x5_video_position,
            x5_type: _this.x5_type,
            x5_fullscreen: _this.x5_fullscreen,
            x5_orientation: _this.x5_orientation,
            autoPlayDelay: _this.autoPlayDelay,
            autoPlayDelayDisplayText: _this.autoPlayDelayDisplayText,
          },
          function (player) {
            console.log("播放器创建好了。");
          }
        );
        _this.instance.on("ready", () => {
          this.$emit("ready", _this.instance);
        });
        _this.instance.on("play", () => {
          this.$emit("play", _this.instance);
        });
        _this.instance.on("pause", () => {
          this.$emit("pause", _this.instance);
        });
        _this.instance.on("ended", () => {
          this.$emit("ended", _this.instance);
        });
        _this.instance.on("liveStreamStop", () => {
          this.$emit("liveStreamStop", _this.instance);
        });
        _this.instance.on("m3u8Retry", () => {
          this.$emit("m3u8Retry", _this.instance);
        });
        _this.instance.on("hideBar", () => {
          this.$emit("hideBar", _this.instance);
        });
        _this.instance.on("waiting", () => {
          this.$emit("waiting", _this.instance);
        });
        _this.instance.on("snapshoted", () => {
          this.$emit("snapshoted", _this.instance);
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.prism-player {
  width: 100%;
  height: 100%;
}
</style>